module.exports = __webpack_public_path__ + "img/partners.2735c592.png";